<template>
  <v-container
    fluid
  >
    <base-material-card
      inline
      icon="mdi-map-marker"
      :title="title"
    >
      <template v-slot:subheader>
        <div
             v-if="isOldCandidate"
             class="old-candidate warning text-center pa-2 white--text v-alert"
        >This an old candidate. Changes are not desired!</div>
      </template>
      <loader v-if="loading"></loader>
      <template v-if="!loading">
        <v-tabs
          v-model="tab1"
          centered
          optional
          @change="tabChange1"
        >
          <v-tab>Location</v-tab>
          <v-tab>Construction</v-tab>
          <v-tab>Construction-Equipment</v-tab>
          <v-tab>Design</v-tab>
          <v-tab>Tenant</v-tab>
        </v-tabs>
        <v-tabs
          v-model="tab2"
          centered
          optional
          @change="tabChange2"
        >
          <v-tab>Transmission</v-tab>
          <v-tab>Contracts</v-tab>
          <v-tab>Access</v-tab>
          <v-tab>Radio frequency</v-tab>
          <v-tab>Permit ministry of health</v-tab>
        </v-tabs>
        <empty-space />
      </template>
      <v-tabs-items
        v-model="selectedTab"
      >
        <v-tab-item>
          <location
            v-if="site"
            :site="site"
            :active="selectedTab == 0"
          />
        </v-tab-item>
        <v-tab-item>
          <construction
            v-if="site"
            :site="site"
            :active="selectedTab == 1"
          />
        </v-tab-item>
        <v-tab-item>
          <construction-equipment
            v-if="site"
            :site="site"
            :active="selectedTab == 2"
          />
        </v-tab-item>
        <v-tab-item>
          <design
            v-if="site"
            :site="site"
            :active="selectedTab == 3"
          />
        </v-tab-item>
        <v-tab-item>
          <tenant
            v-if="site"
            :site="site"
            :active="selectedTab == 4"
          />
        </v-tab-item>
        <v-tab-item>
          <transmission
            v-if="site"
            :site="site"
            :active="selectedTab == 5"
          />
        </v-tab-item>
        <v-tab-item>
          <contract
            v-if="site"
            :site="site"
            :active="selectedTab == 6"
            :auto-open="contractsAutoOpen"
          />
        </v-tab-item>
        <v-tab-item>
          <access
            v-if="site"
            :site="site"
            :active="selectedTab == 7"
          />
        </v-tab-item>
        <v-tab-item>
          <radio-frequency
            v-if="site"
            :site="site"
            :active="selectedTab == 8"
            :auto-open="frequencyAutoOpen"
          />
        </v-tab-item>
        <v-tab-item>
          <permit-ministry-of-health
            v-if="site"
            :site="site"
            :active="selectedTab == 9"
            :auto-open="permitsAutoOpen"
          />
        </v-tab-item>
      </v-tabs-items>
    </base-material-card>
  </v-container>
</template>

<script>
  import Location from '@/views/sites/sections/Location'
  import Construction from '@/views/sites/sections/Construction'
  import ConstructionEquipment from '@/views/sites/sections/ConstructionEquipment'
  import Design from '@/views/sites/sections/Design'
  import Tenant from '@/views/sites/sections/Tenant'
  import Transmission from '@/views/sites/sections/Transmission'
  import Contract from '@/views/sites/sections/Contract'
  import Access from '@/views/sites/sections/Access'
  import PermitMinistryOfHealth from '@/views/sites/sections/PermitMinistryOfHealth'
  import SitesService from '@/services/sites'
  import Loader from '@/components/Loader'
  import RadioFrequency from '@/views/sites/sections/RadioFrequency'
  import EmptySpace from '@/components/EmptySpace'

  export default {
    name: 'View',
    components: { EmptySpace, RadioFrequency, Loader, PermitMinistryOfHealth, Access, Contract, Transmission, Tenant, Design, ConstructionEquipment, Construction, Location },
    data () {
      return {
        id: null,
        site: null,
        tab1: 0,
        tab2: null,
        loading: true,
        contractsAutoOpen: null,
        permitsAutoOpen: null,
        frequencyAutoOpen: null,
      }
    },
    watch: {
      $route: 'fetchData',
      selectedTab: function (newValue, oldValue) {
        if (newValue == null) {
          if (oldValue > 4) {
            setTimeout(() => {
              this.tab1 = null
              this.tab2 = oldValue - 5
            }, 0)
          } else {
            setTimeout(() => {
              this.tab2 = null
              this.tab1 = oldValue
            }, 0)
          }
        }
      },
    },
    mounted () {
      this.fetchData()
    },
    computed: {
      title () {
        if (this.site) {
          return this.site.site_id + ' ' + this.site.site_name
        }
        return 'Site details'
      },
      selectedTab () {
        if (this.tab1 != null) {
          return this.tab1
        } else if (this.tab2 != null) {
          return this.tab2 + 5
        }
        return null
      },
      isOldCandidate () {
        if (!this.site.function_id) {
          return false
        }
        return !this.site.function_id.toUpperCase().startsWith('H')
      },
    },
    methods: {
      switchInLink () {
        const contractId = this.$route.params.contractId
        const permitId = this.$route.params.permitId
        const sectorId = this.$route.params.sectorId
        if (contractId) {
          this.contractsAutoOpen = contractId
          this.tab1 = null
          this.tab2 = 1
        } else if (permitId) {
          this.permitsAutoOpen = permitId
          this.tab1 = null
          this.tab2 = 4
        } else if (sectorId) {
          this.frequencyAutoOpen = sectorId
          this.tab1 = null
          this.tab2 = 3
        }
      },
      fetchData () {
        this.site = null
        this.loading = true
        this.contractsAutoOpen = null
        this.id = this.$route.params.id
        const ss = new SitesService()
        ss.get(this.id).then((response) => {
          this.site = response.data.data
          this.switchInLink()
        }).finally(() => {
          this.loading = false
        })
      },
      tabChange1 () {
        this.tab2 = null
      },
      tabChange2 () {
        if (this.tab1 != null) {
          this.tab1 = null
        }
      },
    },
  }
</script>

<style scoped>
.old-candidate {
  width: 100%;
}
</style>
